import { render } from "./Municipios.vue?vue&type=template&id=0d1787cc"
import script from "./Municipios.vue?vue&type=script&lang=js"
export * from "./Municipios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__